import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, unref as _unref, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/beta-sticker.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-0ad82e70"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "beta-sticker",
  src: _imports_0,
  alt: "Gyre BETA sticker"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { for: "allow-sharing" }
const _hoisted_5 = { class: "goal-sharing-modal-body" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Anyone with this link can view:", -1))
const _hoisted_7 = { class: "center-flex" }
const _hoisted_8 = {
  type: "submit",
  form: "goal-sharing-form",
  class: "btn btn-primary w-100",
  "data-test": "submit-goal-sharing"
}
const _hoisted_9 = {
  key: 0,
  class: "text-danger text-center"
}
const _hoisted_10 = { class: "team-image-container team-image" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { "data-test": "goal-capture-title" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { class: "goal-doc-section" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 0,
  class: "add-goal-container center-flex"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Add Goal", -1))

import { computed, onMounted, provide, ref, watch } from "vue";
import axios, { AxiosError } from "axios";
import { Modal } from "uiv";
import { useRoute } from "vue-router";
import {
  CmsDocument,
  CmsGoalCapturePage,
  CmsRichText,
} from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";
import { csContext } from "../../services/cs-context";
import GoalArea from "../../components/goal-capture/goal-area.vue";
import { TeamGoalApiModel, TeamGoalsApiModel } from "../../api-models";
import { useAxios } from "../../composables/api";
import LoadingPage from "../loading-page.vue";
import { useToggle } from "../../composables/useToggle";
import goalCaptureStore from "../../stores/goal-capture-store";

export interface TeamGoal extends TeamGoalApiModel {
  locked: boolean;
}

interface UpdateGoalModel {
  index: number;
  id: string;
  locked: boolean;
  goalName: string;
  createdById: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-goal-capture-page',
  props: {
    doc: {}
  },
  setup(__props: any) {

const props = __props;
const doc = ref<CmsGoalCapturePage>(props.doc as CmsGoalCapturePage);

const route = useRoute();
const isSharedView = ref(route.query.isSharedLink);
const isSlideOverSession = ref(
  route.fullPath.includes("/resources/session") && route.fullPath.includes("sliding"),
);

const isSlideOverTeam = ref(
  route.fullPath.includes("/team/dashboard") && route.fullPath.includes("sliding"),
);

const { data, promise: getGoalsRequest } = useAxios<TeamGoalsApiModel>(
  `/api/teamgoals/${
    route.query.isSharedLink && route.query.teamId ? route.query.teamId : csContext.currentTeam?.id
  }`,
);

const isTeamAdmin = ref(false);
provide("isTeamAdmin", isTeamAdmin);
const error = ref("");
const teamGoals = ref<TeamGoal[]>([]);
const teamName = ref<string | null>(null);
const teamImgSrc = csContext.currentTeam?.imageUrl;

const analyses = computed(() => doc.value.data.analyses);
const hasData = computed(() => !!data.value && isTeamAdmin.value !== null);

const canAddGoal = computed(() => {
  return !!isTeamAdmin.value && teamGoals.value.every((goal) => goal.locked === true);
});

function refreshTeamGoals() {
  teamGoals.value = [...teamGoals.value];
}

function unlockGoal(index: number, status: boolean) {
  teamGoals.value[index].locked = status;
  refreshTeamGoals();
}

function updateGoal(index: number, goal: UpdateGoalModel) {
  teamGoals.value[index] = {
    ...teamGoals.value[index],
    id: goal.id,
    goalName: goal.goalName,
    locked: goal.locked,
    createdById: goal.createdById,
  };

  refreshTeamGoals();
}

function addGoal() {
  teamGoals.value.push({
    id: "",
    goalName: "",
    teamGoalAnalyses: [],
    createdDate: new Date().toISOString(),
    locked: false,
    createdById: "",
  });
}

async function deleteGoal(goalIndex: number) {
  try {
    const selectedGoal = teamGoals.value[goalIndex];
    if (selectedGoal?.id) {
      axios.delete(`/api/teamgoals/${selectedGoal.id}`);
    }
    teamGoals.value.splice(goalIndex, 1);
  } catch (e: unknown) {
    error.value = (e as AxiosError).message;
  }
}

const { state: isShareModalOpen, toggleState: toggleShareModal } = useToggle(false);
const { state: isLinkCopied, toggleState: toggleLinkCopied } = useToggle(false);
const isSharingEnabled = ref(false);
const goalSharingError = ref<string | null>(null);
const isSavingSharing = ref(false);

function onCopyLinkClick() {
  const goalDocumentLink = `${window.location.origin}/teamgoals?isSharedLink=true&teamId=${csContext.currentTeam?.id}`;
  // copy link to clipboard
  navigator.clipboard.writeText(goalDocumentLink);
  if (!isLinkCopied.value) {
    toggleLinkCopied();
  }
}

async function onSaveSharingClick() {
  if (isSavingSharing.value) {
    return;
  }

  goalSharingError.value = null;

  isSavingSharing.value = true;
  try {
    await axios.patch(`/api/teamsettings/patchteamgoalsharing/${isSharingEnabled.value}`);
    toggleShareModal();
  } catch (e: unknown) {
    goalSharingError.value = "There was an error saving, please try again later";
  } finally {
    isSavingSharing.value = false;
  }
}

function findAndReplaceUnknownTeamNameIfSharedDoc(text: CmsRichText): string {
  const textHtml = cms.asHtml(text);
  if (isSharedView.value) {
    if (teamName.value) {
      // find UNKNOWN_TEAM in the html and replace it with the team name
      return textHtml.replace(/<span>UNKNOWN_TEAM<\/span>/g, `<span>${teamName.value}</span>`);
    }
  }
  return textHtml;
}

const introText = computed(() => {
  return findAndReplaceUnknownTeamNameIfSharedDoc(doc.value.data.introduction);
});

onMounted(async () => {
  const response = await getGoalsRequest;
  isSharingEnabled.value = response.isTeamGoalSharingEnabled;
  teamName.value = response.teamName;
  if (response.teamGoals.length > 0) {
    teamGoals.value = response.teamGoals
      .map((goal) => ({
        id: goal.id,
        goalName: goal.goalName,
        createdDate: goal.createdDate,
        teamGoalAnalyses: goal.teamGoalAnalyses,
        locked: true,
        createdById: goal.createdById,
      }))
      .sort((a, b) => (new Date(a.createdDate) as any) - (new Date(b.createdDate) as any));
  } else {
    addGoal();
  }

  goalCaptureStore.initSuggestionsStore(teamGoals.value);

  if (!isSharedView.value) {
    const { data: isTeamLead } = useAxios<boolean>(
      `/api/grouproles/isgroupadmin/${csContext.currentTeam?.id ?? route.query.teamId}`,
    );
    watch(isTeamLead, (value) => {
      if (value !== null) {
        isTeamAdmin.value = value;
      }
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (!hasData.value)
    ? (_openBlock(), _createBlock(LoadingPage, { key: 0 }))
    : (_openBlock(), _createElementBlock("main", _hoisted_1, [
        (doc.value.tags.includes('BETA'))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["beta-container", { 'slide-over-sesson': isSlideOverSession.value, 'slide-over-team': isSlideOverTeam.value }])
            }, _hoisted_3, 2))
          : _createCommentVNode("", true),
        _createVNode(_unref(Modal), {
          modelValue: _unref(isShareModalOpen),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(isShareModalOpen) ? (isShareModalOpen).value = $event : null))
        }, {
          header: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _withModifiers(onSaveSharingClick, ["prevent"]),
              id: "goal-sharing-form"
            }, [
              _createElementVNode("label", _hoisted_4, [
                _createTextVNode(" Allow link sharing? "),
                _withDirectives(_createElementVNode("input", {
                  name: "allow-sharing",
                  type: "checkbox",
                  class: "toggle-switch-checkbox",
                  style: {"vertical-align":"bottom","margin-left":"10px"},
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isSharingEnabled).value = $event)),
                  "data-test": "goal-sharing-toggle"
                }, null, 512), [
                  [_vModelCheckbox, isSharingEnabled.value]
                ])
              ])
            ], 32)
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(toggleShareModal) && _unref(toggleShareModal)(...args))),
                type: "button",
                class: "btn btn-default w-100"
              }, " Close "),
              _createElementVNode("button", _hoisted_8, _toDisplayString(isSavingSharing.value ? "Saving..." : "Save"), 1)
            ]),
            (goalSharingError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(goalSharingError.value), 1))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              (!_unref(isLinkCopied))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: onCopyLinkClick,
                    type: "button",
                    class: "btn btn-default-share",
                    "data-test": "copy-goal-sharing-link"
                  }, " Copy link "))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: onCopyLinkClick,
                    type: "button",
                    class: "btn btn-default-tick"
                  }, " Copied! "))
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_10, [
          (_unref(teamImgSrc))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(teamImgSrc),
                alt: "team image"
              }, null, 8, _hoisted_11))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("h1", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(teamName.value), 1),
          _hoisted_14,
          _createTextVNode(" " + _toDisplayString(_unref(cms).asText(doc.value.data.title)), 1)
        ]),
        (!isSharedView.value && isTeamAdmin.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(toggleShareModal) && _unref(toggleShareModal)(...args))),
              style: {"margin-top":"20px"},
              class: "btn btn-primary-share btn-sm",
              type: "button",
              "data-test": "goal-share-button"
            }, " Share "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            innerHTML: introText.value,
            class: "goal-doc-paragraph"
          }, null, 8, _hoisted_16)
        ]),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamGoals.value, (goal, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${goal.goalName}-${index}`
            }, [
              _createVNode(GoalArea, {
                "goal-index": index,
                goal: goal,
                "cms-analyses": analyses.value,
                "suggestion-prompt": doc.value.data.suggestion_prompt.data.prompt,
                locked: goal.locked,
                "onUpdate:lockStatus": unlockGoal,
                "onUpdate:goal": updateGoal,
                onDeleteGoal: deleteGoal
              }, null, 8, ["goal-index", "goal", "cms-analyses", "suggestion-prompt", "locked"])
            ]))
          }), 128)),
          (canAddGoal.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary-fab-plus",
                  tabindex: "0",
                  onClick: addGoal,
                  onKeyup: _withKeys(addGoal, ["enter"]),
                  "data-test": "add-goal-button"
                }, null, 32)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
}
}

})